import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

// Define a type for the slice state
export interface PayrollPageState {
    selectedTab: string;
}

// Define the initial state using that type
const initialState: PayrollPageState = {
    selectedTab: "-1",
};

export const payrollPageSlice = createSlice({
    name: "payrollPage",
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        updatePayrollPageSelectedTab: (state, action: PayloadAction<string>) => {
            state.selectedTab = action.payload;
        },
    },
});

export const { updatePayrollPageSelectedTab } = payrollPageSlice.actions;
export default payrollPageSlice.reducer;
